module.exports = __webpack_public_path__ + "static/media/hm1.56c26afc.PNG";